import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Trophy, Crown } from "@phosphor-icons/react";
import WeeklyPrizeCard from "@/components/WeeklyPrizeCard";

export default function Leaderboard() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/leaderboard").then(({ data }) => setRows(data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 md:p-8 max-w-4xl mx-auto space-y-6" data-testid="leaderboard-page">
      <div>
        <h1 className="font-heading text-3xl md:text-4xl font-black">Leaderboard</h1>
        <p className="text-white/60 mt-1">Top engaged users on Tain — watch time, likes, comments, shares, uploads, gifts.</p>
      </div>

      <WeeklyPrizeCard />

      {loading ? (
        <p className="text-white/60">Loading…</p>
      ) : (
        <div className="glass rounded-2xl overflow-hidden">
          {rows.map((u, idx) => {
            const isMe = u.user_id === user?.user_id;
            const rank = idx + 1;
            return (
              <div
                key={u.user_id}
                data-testid={`leader-row-${rank}`}
                className={`flex items-center gap-4 p-4 border-b border-white/5 ${isMe ? "bg-blue-500/10" : ""}`}
              >
                <div className="w-10 flex justify-center">
                  {rank === 1 ? (
                    <Crown size={24} weight="fill" className="text-yellow-400" />
                  ) : rank === 2 ? (
                    <Trophy size={22} weight="fill" className="text-white/70" />
                  ) : rank === 3 ? (
                    <Trophy size={22} weight="fill" className="text-orange-400" />
                  ) : (
                    <span className="font-heading text-lg font-bold text-white/50">{rank}</span>
                  )}
                </div>
                {u.picture ? (
                  <img src={u.picture} alt="" className="w-10 h-10 rounded-full" />
                ) : (
                  <div className="w-10 h-10 rounded-full bg-white/10" />
                )}
                <div className="flex-1 min-w-0">
                  <p className="font-heading font-bold truncate">
                    {u.name} {isMe && <span className="text-xs text-blue-400 ml-1">(You)</span>}
                  </p>
                  <p className="text-xs text-white/50">${(u.balance || 0).toFixed(2)} earned</p>
                </div>
                <p className="font-heading font-black text-blue-400 text-lg" data-testid={`leader-score-${rank}`}>
                  {(u.engagement_score || 0).toLocaleString()}
                  <span className="text-[10px] text-white/50 ml-1 font-normal">cr</span>
                </p>
              </div>
            );
          })}
          {rows.length === 0 && (
            <p className="text-white/50 text-center py-8">No creators yet.</p>
          )}
        </div>
      )}
    </div>
  );
}
